// Constants for the frontend application
// This file centralizes important configuration values used throughout the app

// API Base URL determination with fallback strategy
export const getApiBaseUrl = () => {
  // 1. Check for runtime config from window.ENV (set by Docker)
  if (window.ENV && window.ENV.API_URL) {
    return window.ENV.API_URL;
  }
  
  // 2. Check for Vite environment variables
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  // 3. Check for Azure Static Web Apps backend routing
  if (window.location.hostname.includes('azurestaticapps.net') || 
      window.location.hostname.includes('azurewebsites.net') ||
      window.location.hostname === 'membasuite.com') {
    return '/api';
  }
  
  // 4. Default fallback for development
  return 'http://localhost:5000';
};

// Expose the API_BASE_URL constant used by services
export const API_BASE_URL = getApiBaseUrl();

// Add other application constants below
export const APP_NAME = 'Transform';
export const DEFAULT_PAGINATION_LIMIT = 10;
export const AUTH_TOKEN_KEY = 'auth_token';
export const TENANT_ID_KEY = 'tenant_id';

// Message types
export const MESSAGE_TYPES = {
  DIRECT: 'direct',
  BROADCAST: 'broadcast'
};

// User roles
export const USER_ROLES = {
  ADMIN: 'admin',
  MEMBER: 'member',
  SUPERADMIN: 'superadmin'
};